import axios from 'axios';
import { getHost } from '../utils';
import Auth from '../Auth/auth';
import AuthService from '../../services/AuthService';
import { cleanLocalStorage } from '../../components/Navbar/LogoutIcon';

const INVALID_TOKEN_MSG = 'Invalid access token';

const initClient = () => {
  return axios.create({
    baseURL: getHost(),
  });
};

const isUnauthorized = error => {
  return (
    error?.response?.status === 401 &&
    (error?.response?.statusText === 'Unauthorized' ||
      error?.response?.data?.message === INVALID_TOKEN_MSG)
  );
};

let isRefreshing = false;
async function getRequest(req) {
  let client = null;

  try {
    if (client === null) {
      client = initClient();
    }

    client.interceptors.request.use(config => {
      const authData = Auth.userData();

      if (authData && authData.token) {
        config.headers.Authorization = `${authData.token.token_type} ${authData.token.access_token}`;
      }

      return config;
    });

    client.interceptors.response.use(
      response => {
        return response;
      },
      async error => {
        const originalRequest = error.config;
        // If the server responds with a 401 status (Unauthorized), try to refresh the token
        if (isUnauthorized(error)) {
          if (originalRequest._retry && isRefreshing) {
            console.log(error);
            client.defaults.headers = {};
            await cleanLocalStorage();
            return Promise.reject(error);
          }

          const authData = Auth.userData();
          originalRequest._retry = true;
          isRefreshing = true;
          if (authData && authData.token) {
            try {
              const updatedToken = await AuthService().refreshToken({
                refreshToken: authData.token?.refresh_token,
              });

              Auth.updateAuthData(updatedToken);

              const token = `${updatedToken.token_type} ${updatedToken.access_token}`;
              // Update the authorization header
              originalRequest.headers.Authorization = token;
              // Retry the original request
              return client(originalRequest);
            } catch (error) {
              console.log(error);
              client.defaults.headers = {};
              await cleanLocalStorage();
              return Promise.reject(error);
            } finally {
              isRefreshing = false;
            }
          }
        }

        return Promise.reject(error);
      }
    );

    const response = await client.request({
      ...req,
      url: req.url,
    });

    if (response.data.status === 'fail') {
      throw response.data;
    }

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export default function Requestor() {
  return {
    getRequest,
  };
}
